// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nU-l","colBig":"styles_colBig__1CEWb","colSmall":"styles_colSmall__1Drhn","shopifyNameWrapper":"styles_shopifyNameWrapper__3UWDs"};